// Pflichtangaben vor Livegang vervollständigen. Unbekannte Stammdaten werden
// absichtlich nicht geraten, sondern als fehlend markiert.
export const legalProfile = {
  brandName: "mutzur",
  providerName: "mutzur UG (haftungsbeschränkt)",
  representative: "Charly Schötz",
  street: "Leisniger Straße 39",
  postalCode: "01127",
  city: "Dresden",
  country: "Deutschland",
  email: "kontakt@mutzur.de",
  phone: "+49 151 29796172",
  vatId: "",
  registerCourt: "Dresden",
  registerNumber: "HRB 47651",
  lastUpdated: "1. April 2026",
};

function hasValue(value: string) {
  return value.trim().length > 0;
}

function fallback(value: string, label: string) {
  return hasValue(value) ? value : `Bitte ergänzen: ${label}`;
}

export const legalChecklist = [
  {
    label: "vollständiger Name bzw. Firmierung des Diensteanbieters",
    complete: hasValue(legalProfile.providerName),
  },
  {
    label: "ladungsfähige Anschrift",
    complete:
      hasValue(legalProfile.street) &&
      hasValue(legalProfile.postalCode) &&
      hasValue(legalProfile.city),
  },
];

export const missingLegalChecklist = legalChecklist
  .filter((item) => !item.complete)
  .map((item) => item.label);

export const hasIncompleteLegalProfile = missingLegalChecklist.length > 0;

export function getProviderName() {
  return fallback(legalProfile.providerName, "Name/Firma");
}

export function getRepresentative() {
  return fallback(legalProfile.representative, "vertretungsberechtigte Person");
}

export function getAddressLines() {
  if (
    hasValue(legalProfile.street) &&
    hasValue(legalProfile.postalCode) &&
    hasValue(legalProfile.city)
  ) {
    return [
      legalProfile.street,
      `${legalProfile.postalCode} ${legalProfile.city}`,
      legalProfile.country,
    ].filter(hasValue);
  }

  return ["Bitte ergänzen: ladungsfähige Anschrift"];
}

export function hasRepresentative() {
  return hasValue(legalProfile.representative);
}

export function hasVatId() {
  return hasValue(legalProfile.vatId);
}

export function hasCommercialRegister() {
  return hasValue(legalProfile.registerCourt) && hasValue(legalProfile.registerNumber);
}

export function getDisputeResolutionText() {
  return "Zur Teilnahme an Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle sind wir nicht verpflichtet und nehmen daran nicht teil.";
}
